import { render, staticRenderFns } from "./NotificacoesDiaTable.vue?vue&type=template&id=ebf490ea&scoped=true&"
import script from "./NotificacoesDiaTable.vue?vue&type=script&lang=js&"
export * from "./NotificacoesDiaTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificacoesDiaTable.vue?vue&type=style&index=0&id=ebf490ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf490ea",
  null
  
)

export default component.exports